//service
import http from "./httpService";
import config from "./config"






//service 
export const getExam = (user) => {
    return http.get(
        `${config.apiAddress}eTest/getExam/${user}`,
    );
};



export const getExamInfo = (examId) => {
    return http.get(
        `${config.apiAddress}eTest/getExamInfo/${examId}`,
    );
};


export const checkStartExam = (username,examId) => {
    return http.get(
        `${config.apiAddress}eTest/checkStartExam/${username}/${examId}`,
    );
};
export const endExam = (username,mark,examId,isPassed) => {
    console.log(username,mark,examId,isPassed);
    return http.get(
        `${config.apiAddress}eTest/checkStartExam/${username}/${mark}/${examId}/${isPassed}`,
    );
};


